import { messages as portugueseMessages } from './pt';
import { messages as englishMessages } from './en';
import { messages as espanholMessages } from './es';

const messages = {
    ...portugueseMessages,
    ...englishMessages,
    ...espanholMessages,
}

export { messages }